import { render } from "./ModalResultPreTest.vue?vue&type=template&id=1cd0ed90"
import script from "./ModalResultPreTest.vue?vue&type=script&lang=js"
export * from "./ModalResultPreTest.vue?vue&type=script&lang=js"
script.render = render

export default script